import { attr } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import BaseModel from 'volta/models/base-model';

import type { IResourceName } from 'volta/models/base-model';
import type { TSkuProperty, TRTSProperty } from './forecast-project-header';

export const ForecastProjectMlPipelineResourceName: IResourceName = {
  singular: 'forecastProjectMlPipeline',
  plural: 'forecastProjectMlPipelines'
};

export default class ForecastProjectMlPipeline extends BaseModel {
  @attr('string')
  declare fpHeaderId: string;

  @attr('string')
  modelName?: string;

  @attr('array', { defaultValue: () => [] })
  declare rtsModel: TRTSProperty[];

  @attr('array', { defaultValue: () => [] })
  declare metadataModel: TSkuProperty[];

  @attr('string')
  scheduleId?: string;

  @attr('string')
  declare createdBy: string;

  @attr('date')
  declare createdAt: Date;

  @attr('string')
  updatedBy?: string;

  @attr('date')
  declare updatedAt: Date;

  @attr('number', { defaultValue: 1 })
  declare version: number;

  [Type] = 'forecast-project-ml-pipeline' as const;
}
